import BasePage from './BasePage';

export * from './BasePageProps';
export default BasePage;
